export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/tour/back',
      component: () => import('@/page/distributor/component/admin-layout/index.vue'),
      children: [
        {
          path: '/distributor/tour/back/tour-independent-order-list',
          name: 'distributor-tour-back-tour-independent-order-list',
          component: () => import('@/page/distributor/tour/back/independentTourOrder/index.vue'),
          meta: {
            nav_list_for_admin_layout_head_nav: [
              { name: `旅游订单` },
              { name: `自由行列表` },
            ],
          },
        },
      ]
    },
  ]
};
